// extracted by mini-css-extract-plugin
export default {"registration":"styles_registration__nR7O7","submit":"styles_submit__hopNG","error":"styles_error__EauHP"};